import React from "react";

function ClicktoolLogoMark(props) {
  return (
    <svg viewBox="0 0 680 680" height="60" {...props}>
      <defs>
        <style>{".prefix__cls-1{fill:#fff}.prefix__cls-3{fill:#424242}"}</style>
      </defs>
      <title>{"CLICKTOOL_MARK"}</title>
      <g id="prefix__Gear">
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 340 340"
          to="360 340 340"
          dur="4s"
          repeatCount="indefinite"
        />
        <path d="M53.32 157.31a339.93 339.93 0 0127.46-37.21l49 9.42a297.17 297.17 0 01133.09-76.86L279.2 5.53A340.17 340.17 0 01325.14.38C330.07.16 335 0 340 0s9.93.16 14.86.38a340.17 340.17 0 0145.94 5.15l16.33 47.13a297.17 297.17 0 01133.12 76.86l49-9.42a339.93 339.93 0 0127.46 37.21q8 12.49 14.88 25.7a337 337 0 0118.56 42.31l-32.74 37.78a298.12 298.12 0 010 153.77l32.71 37.78A338.35 338.35 0 01641.58 497q-6.89 13.2-14.88 25.69a339.85 339.85 0 01-27.45 37.21l-49-9.42a297.14 297.14 0 01-133.17 76.91l-16.32 47.12a340.36 340.36 0 01-45.94 5.15c-4.93.22-9.87.38-14.85.38s-9.92-.16-14.85-.38a340.36 340.36 0 01-45.94-5.15l-16.32-47.12a297.14 297.14 0 01-133.17-76.91l-49 9.42a339.85 339.85 0 01-27.39-37.25q-8-12.48-14.88-25.69a338.35 338.35 0 01-18.55-42.31l32.71-37.78a298.12 298.12 0 010-153.77l-32.7-37.78A337 337 0 0138.44 183q6.89-13.2 14.88-25.7" />
        <path
          className="prefix__cls-1"
          d="M245.35 103.22a253.16 253.16 0 0149-14.07L310 44c9.86-1 19.85-1.5 30-1.5s20.11.52 30 1.5l15.64 45.15a255.2 255.2 0 01148.76 85.92l46.87-9a296.42 296.42 0 0130 51.91l-31.21 36a254 254 0 0112.28 49.57 253.49 253.49 0 010 72.84A253.2 253.2 0 01580.1 426l31.21 36a296.69 296.69 0 01-30 51.91l-46.86-9a256 256 0 01-99.81 71.89 252.84 252.84 0 01-49 14.06L370 636c-9.86 1-19.85 1.5-30 1.5s-20.1-.52-30-1.5l-15.6-45.15a253.38 253.38 0 01-112.09-50.53 256.45 256.45 0 01-36.75-35.42l-46.86 9a296.69 296.69 0 01-30-51.91L99.9 426a253.2 253.2 0 01-12.27-49.6 253.49 253.49 0 010-72.84A254 254 0 0199.91 254L68.7 218a296.79 296.79 0 0130-51.91l46.87 9a255.77 255.77 0 0199.75-71.85"
        />
      </g>
      <g id="prefix__Hex">
        <path
          fill="#2cb8d2"
          d="M561 467.59l-221 127.6-221-127.6V212.41l221-127.6 221 127.6v255.18z"
        />
        <path
          className="prefix__cls-3"
          d="M549.44 340A25.51 25.51 0 00524 314.5H407.52a71.38 71.38 0 010 51H524a25.51 25.51 0 0025.44-25.5zM340 280.49a59.46 59.46 0 00-53.71 34h41a12.78 12.78 0 0112.71 12.4v26.22a12.76 12.76 0 01-12.73 12.39h-41a59.46 59.46 0 1053.71-85z"
        />
        <path
          className="prefix__cls-1"
          d="M340 510.89l148-85.44-74-42.73-74 42.73-74-42.73v-85.44l74-42.73 74 42.73 74-42.73-148-85.45-148 85.45v170.9l148 85.44z"
        />
      </g>
    </svg>
  );
}

export default ClicktoolLogoMark;
